<div class="coupon-status-popup-root">
    <div class="top">
        <span>{{this.labels.couponStatusText}}</span>
        <app-icon-click flat (click)="emitCloseClick()">cancel</app-icon-click>
    </div>
    <div class="chips-area">
        <mat-chip-list [multiple]="false" [formControl]="chipListCtrl">
            <mat-chip *ngFor="let i of chipOptions">{{i.name}} <mat-icon>{{i.icon}}</mat-icon></mat-chip>
        </mat-chip-list>
    </div>
    <div *ngIf="chipSelected === 'redeemed'" class="form-area">
        <app-input [label]="labels.formDate" type="date" [control]="form.controls.date"></app-input>
        <app-input [label]="labels.formInvoice" type="text" [control]="form.controls.invoice" [prefix]="'#'"></app-input>
        <app-input [label]="labels.formValue" type="text" [control]="form.controls.discount" [prefix]="currency"></app-input>
        <app-input [label]="labels.formReseller" type="text" [control]="form.controls.reseller"></app-input>
    </div>
    <div *ngIf="chipSelected === 'canceled'" class="form-area" >
        <p>
            {{this.labels.textCancel}}
        </p>
        <app-checkbox [formGroup]="form" abstractFormControlName="cancel">{{labels.confirmCancel}}</app-checkbox>
    </div>
    <div class="button-area">
        <button mat-raised-button class="change-btn">{{this.labels.changeStatus}}</button>
        <button mat-raised-button color="primary" (click)="emitCloseClick()">{{this.labels.cancel}}</button>
    </div>
</div>
 